// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Register-space1-WEukh {
	margin-bottom: 6px !important;
}

.Register-space2-quncX {
	margin-bottom: 12px !important;
}

.Register-space3-eXzIj {
	margin-bottom: 18px !important;
}

.Register-space4-MwSek {
	margin-bottom: 24px !important;
}

.Register-space5-YZM4O {
	margin-bottom: 30px !important;
}

.Register-space6-pzTpu {
	margin-bottom: 36px !important;
}

.Register-space7-uV8g3 {
	margin-bottom: 42px !important;
}

.Register-space8-wMFFj {
	margin-bottom: 48px !important;
}

.Register-spaceTop1-KDD3f {
	margin-top: 6px !important;
}

.Register-spaceTop2-Sworu {
	margin-top: 12px !important;
}

.Register-spaceTop3-vDTFa {
	margin-top: 18px !important;
}

.Register-spaceTop4-B6UB1 {
	margin-top: 24px !important;
}

.Register-spaceTop5-LKWXm {
	margin-top: 30px !important;
}

.Register-spaceTop6-IpI0U {
	margin-top: 36px !important;
}

.Register-spaceTop7-q1W1Q {
	margin-top: 42px !important;
}

.Register-spaceTop8-Bqogk {
	margin-top: 48px !important;
}

.Register-noMargin-lTGKw {
	margin: 0px !important;
}

.Register-padding1-RbwcR {
	padding-bottom: 6px !important;
}

.Register-padding2-Ca7E9 {
	padding-bottom: 12px !important;
}

.Register-padding3-xVeCr {
	padding-bottom: 18px !important;
}

.Register-padding4-G0wFi {
	padding-bottom: 24px !important;
}

.Register-padding5-YtpGo {
	padding-bottom: 30px !important;
}

.Register-padding6-Gepex {
	padding-bottom: 36px !important;
}

.Register-padding7-iJC8T {
	padding-bottom: 42px !important;
}

.Register-paddingTop1-fYDT8 {
	padding-top: 6px !important;
}

.Register-paddingTop2-A1mFg {
	padding-top: 12px !important;
}

.Register-paddingTop3-twr_q {
	padding-top: 18px !important;
}

.Register-paddingTop4-XYsf_ {
	padding-top: 24px !important;
}

.Register-paddingTop5-ibHJH {
	padding-top: 30px !important;
}

.Register-paddingTop6-fwU78 {
	padding-top: 36px !important;
}

.Register-paddingTop7-GoPO8 {
	padding-top: 42px !important;
}

.Register-noPadding-oIEu7 {
	padding: 0px !important;
}

.Register-spaceMarginBottom0-co9ph {
	margin-bottom: 0;
}

.Register-textBold-rSWgs {
	font-weight: 500 !important;
}

.Register-textBolder-zC4AG {
	font-weight: 700 !important;
}

.Register-textNormal-_TqrR {
	font-weight: normal !important;
}

/*New Design Text Colors */

.Register-textDarkBlue-LCHk0 {
	color: rgb(20, 39, 94) !important;
}

.Register-textLightBlue-rdBHF {
	color: rgb(57, 87, 106) !important;
}

.Register-textLightSandleGreen-_LDIj {
	color: rgb(76, 86, 41) !important;
}

.Register-textLightBrown-1xmbe {
	color: rgb(115, 79, 33) !important;
}

.Register-textMediumMaroon-NaAhl {
	color: rgb(87, 37, 51) !important;
}

.Register-textBrown-Zp21J {
	color: rgb(160, 47, 24) !important;
}

.Register-textMaroon-d4A7Q {
	color: rgb(155, 49, 67) !important;
}

.Register-textDarkBrown-XjvJf {
	color: rgb(83, 18, 16) !important;
}

.Register-textMediumBrown-RhJdY {
	color: rgb(142, 28, 10) !important;
}

.Register-textSkyBlue-FdDRr {
	color: rgb(37, 117, 141) !important;
}

.Register-textGray-DAMh9 {
	color: rgb(77, 65, 51) !important;
}

.Register-root-wPhWS {
	padding-left: 20px;
	padding-right: 20px;
}

.Register-container-Q81pW {
	margin: 40px auto;
	padding: 20px;
	max-width: 380px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/routes/register/Register.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1LA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,gBAAgB;AACjB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n.root {\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n}\n\n.container {\n\tmargin: 40px auto;\n\tpadding: 20px;\n\tmax-width: 380px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Register-space1-WEukh`,
	"space2": `Register-space2-quncX`,
	"space3": `Register-space3-eXzIj`,
	"space4": `Register-space4-MwSek`,
	"space5": `Register-space5-YZM4O`,
	"space6": `Register-space6-pzTpu`,
	"space7": `Register-space7-uV8g3`,
	"space8": `Register-space8-wMFFj`,
	"spaceTop1": `Register-spaceTop1-KDD3f`,
	"spaceTop2": `Register-spaceTop2-Sworu`,
	"spaceTop3": `Register-spaceTop3-vDTFa`,
	"spaceTop4": `Register-spaceTop4-B6UB1`,
	"spaceTop5": `Register-spaceTop5-LKWXm`,
	"spaceTop6": `Register-spaceTop6-IpI0U`,
	"spaceTop7": `Register-spaceTop7-q1W1Q`,
	"spaceTop8": `Register-spaceTop8-Bqogk`,
	"noMargin": `Register-noMargin-lTGKw`,
	"padding1": `Register-padding1-RbwcR`,
	"padding2": `Register-padding2-Ca7E9`,
	"padding3": `Register-padding3-xVeCr`,
	"padding4": `Register-padding4-G0wFi`,
	"padding5": `Register-padding5-YtpGo`,
	"padding6": `Register-padding6-Gepex`,
	"padding7": `Register-padding7-iJC8T`,
	"paddingTop1": `Register-paddingTop1-fYDT8`,
	"paddingTop2": `Register-paddingTop2-A1mFg`,
	"paddingTop3": `Register-paddingTop3-twr_q`,
	"paddingTop4": `Register-paddingTop4-XYsf_`,
	"paddingTop5": `Register-paddingTop5-ibHJH`,
	"paddingTop6": `Register-paddingTop6-fwU78`,
	"paddingTop7": `Register-paddingTop7-GoPO8`,
	"noPadding": `Register-noPadding-oIEu7`,
	"spaceMarginBottom0": `Register-spaceMarginBottom0-co9ph`,
	"textBold": `Register-textBold-rSWgs`,
	"textBolder": `Register-textBolder-zC4AG`,
	"textNormal": `Register-textNormal-_TqrR`,
	"textDarkBlue": `Register-textDarkBlue-LCHk0`,
	"textLightBlue": `Register-textLightBlue-rdBHF`,
	"textLightSandleGreen": `Register-textLightSandleGreen-_LDIj`,
	"textLightBrown": `Register-textLightBrown-1xmbe`,
	"textMediumMaroon": `Register-textMediumMaroon-NaAhl`,
	"textBrown": `Register-textBrown-Zp21J`,
	"textMaroon": `Register-textMaroon-d4A7Q`,
	"textDarkBrown": `Register-textDarkBrown-XjvJf`,
	"textMediumBrown": `Register-textMediumBrown-RhJdY`,
	"textSkyBlue": `Register-textSkyBlue-FdDRr`,
	"textGray": `Register-textGray-DAMh9`,
	"root": `Register-root-wPhWS`,
	"container": `Register-container-Q81pW`
};
module.exports = ___CSS_LOADER_EXPORT___;
